import { useState, useEffect } from "react"
import { useAppSelector } from "."
import { getSession } from "../../app/state/appSessionStorage"

export interface SignInStatus {
  apiToken: string | undefined
  oauthIdToken: string | undefined
  signedIn: boolean
}

const useSignInStatus = (): SignInStatus => {
  const apiToken = useAppSelector((state) => state.userSession.apiToken)
  const { oauthIdToken } = getSession()


  const [signedIn, setSignedIn] = useState<boolean>()

  useEffect(() => {
    setSignedIn(apiToken && apiToken.length > 0 || oauthIdToken && oauthIdToken.length > 0)
  }, [apiToken, oauthIdToken])

  return {
    apiToken,
    oauthIdToken,
    signedIn
  }
}

export default useSignInStatus
